import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Section overline label used across sections for editorial consistency.
export const Overline = ({ children, className = "" }) => (
  <span className={`overline text-[var(--green)] ${className}`}>{children}</span>
);
